import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, defer, map } from 'rxjs';
import { StorageService } from './storage.service';
import { STORE_SAVED_CONFIGURATION_KEY, STORED_OKTA_USER_DETAILS } from '../utils/Constants';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private asyncFunctionCompletedSubject = new BehaviorSubject<boolean>(false);
  asyncFunctionCompleted$ = this.asyncFunctionCompletedSubject.asObservable();

  private countriesUrl = 'assets/json/countries.json';
  private languagesUrl = 'assets/json/languages.json';
  //private savedConfigurationsUrl = 'assets/json/saved-config3.json';
  private savedConfigurationsUrl = environment.caluwin_api.config_base_url + environment.caluwin_api.endpoints.config_list;
  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private httpService: HttpService
  ) { }

  getCountries(): Observable<any[]> {
    return this.http.get<any[]>(this.countriesUrl);
  }

  getLanguages(): Observable<any[]> {
    return this.http.get<any[]>(this.languagesUrl);
  }

  getSavedConfiguration(userId:string): Observable<any[]> {
    const url = this.savedConfigurationsUrl.replace('{userId}', userId);
    return defer(async () => {
      return this.httpService.executeWithAuthPolicy('GET', {
        url,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });
    }).pipe(map((response: any) => response.data as any[]));
  }

  async informOnAsyncFunctionCompletion() {
    // Perform your async operations here
    await this.performAsyncOperation();

    // Once the async operation is complete, notify subscribers
    this.asyncFunctionCompletedSubject.next(true);
  }

  private async performAsyncOperation() {
    // Your async code here
    await new Promise(resolve => setTimeout(resolve, 2000)); // Example delay
  }

  storeUserSavedConfiguration(savedConfig:any){
    this.storageService.set(STORE_SAVED_CONFIGURATION_KEY,savedConfig);
  }

  getUserSavedConfigurations() {
    this.storageService.get(STORE_SAVED_CONFIGURATION_KEY);
  }

  getOktaUserDetails() {
    this.storageService.get(STORED_OKTA_USER_DETAILS);
  }
}
